// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
	margin:0px;
	padding:0px;
	font-family: 'Open Sans', sans-serif;
}
.primary-color {
    color: #5C58FC;
}

/* Footer */
footer {
    background-color: #5B5B5B;
    text-align: center;
    padding: 16px 0;
}

footer p {
    color: rgb(255 255 255 / 50%);
    font-size: 14px;
    font-weight: 300;
}
/* End Footer */


@media only screen and (max-width:991px){
/* Header */	
.navigation {
    display: none;
}

.toggle-btn {
    display: block;
}

header .container-fluid {
    padding: 0 15px;
}
.main-menu li {
    border-right: none;
}
.navigation.show-menu {
    display: block;
    position: fixed;
    background-color: #fff;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100vh;
    padding-left: 25%;
	z-index: 999;
}

.show-menu .cross-btn {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 20px;
}

ul.main-menu {
    background-color: #F9F9F9;
    padding: 130px 20px 20px 20px;
    height: 100%;
    display: inline-block;
    width: 100%;
}

ul.main-menu li {
    width: 100%;
}

.main-menu li a {
    color: #222222 !important;
    margin: 7px 0;
    display: inline-block;
}
/* End Header */	

}
@media only screen and (max-width:767px){
	
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;CACC,UAAU;CACV,WAAW;CACX,oCAAoC;AACrC;AACA;IACI,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;AACA,eAAe;;;AAGf;AACA,WAAW;AACX;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,iBAAiB;CACpB,YAAY;AACb;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,YAAY;IACZ,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,qBAAqB;AACzB;AACA,eAAe;;AAEf;AACA;;AAEA","sourcesContent":["body{\n\tmargin:0px;\n\tpadding:0px;\n\tfont-family: 'Open Sans', sans-serif;\n}\n.primary-color {\n    color: #5C58FC;\n}\n\n/* Footer */\nfooter {\n    background-color: #5B5B5B;\n    text-align: center;\n    padding: 16px 0;\n}\n\nfooter p {\n    color: rgb(255 255 255 / 50%);\n    font-size: 14px;\n    font-weight: 300;\n}\n/* End Footer */\n\n\n@media only screen and (max-width:991px){\n/* Header */\t\n.navigation {\n    display: none;\n}\n\n.toggle-btn {\n    display: block;\n}\n\nheader .container-fluid {\n    padding: 0 15px;\n}\n.main-menu li {\n    border-right: none;\n}\n.navigation.show-menu {\n    display: block;\n    position: fixed;\n    background-color: #fff;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    padding-left: 25%;\n\tz-index: 999;\n}\n\n.show-menu .cross-btn {\n    display: inline-block;\n    position: absolute;\n    right: 10px;\n    top: 20px;\n}\n\nul.main-menu {\n    background-color: #F9F9F9;\n    padding: 130px 20px 20px 20px;\n    height: 100%;\n    display: inline-block;\n    width: 100%;\n}\n\nul.main-menu li {\n    width: 100%;\n}\n\n.main-menu li a {\n    color: #222222 !important;\n    margin: 7px 0;\n    display: inline-block;\n}\n/* End Header */\t\n\n}\n@media only screen and (max-width:767px){\n\t\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
